import React from 'react';
import { Typography, Card, Row, Col, Button, Space } from 'antd';
import { 
  PhoneOutlined,
  MailOutlined,
  GlobalOutlined,
  MessageOutlined,
  ClockCircleOutlined,
  EnvironmentOutlined,
  UserOutlined,
  SafetyOutlined
} from '@ant-design/icons';

const { Title, Paragraph, Text } = Typography;

const Contact = () => {
  const contactMethods = [
    {
      icon: <GlobalOutlined />,
      title: '官方网站',
      content: 'https://manage.net.cn',
      description: '访问我们的官方网站了解更多信息'
    },
    {
      icon: <MessageOutlined />,
      title: '在线客服',
      content: '应用内个人中心',
      description: '登录后在个人中心联系在线客服'
    },
    {
      icon: <MailOutlined />,
      title: '技术支持',
      content: 'support@manage.net.cn',
      description: '发送邮件获取技术支持'
    },
    {
      icon: <PhoneOutlined />,
      title: '客服热线',
      content: '400-888-8888',
      description: '工作日 9:00-18:00 提供电话支持'
    }
  ];

  const businessHours = [
    { day: '周一至周五', time: '9:00 - 18:00', status: '正常服务' },
    { day: '周六', time: '10:00 - 16:00', status: '有限服务' },
    { day: '周日及节假日', time: '暂停服务', status: '紧急联系' }
  ];

  const faqItems = [
    {
      question: '如何注册管理师账号？',
      answer: '您可以通过手机号注册，或使用微信一键登录。注册后即可使用基础功能。'
    },
    {
      question: '如何升级为高级会员？',
      answer: '在个人中心点击"卡密商城"，购买激活码即可升级为高级会员，解锁全部20个功能模块。'
    },
    {
      question: '数据安全如何保障？',
      answer: '我们采用HTTPS加密传输，密码bcrypt加密存储，定期备份数据，确保您的信息安全。'
    },
    {
      question: '支持哪些平台？',
      answer: '支持Web端、Android/iOS移动APP、微信小程序，数据云端同步。'
    },
    {
      question: '如何获得推荐奖励？',
      answer: '在个人中心点击"一键分享"，将推荐链接分享给好友，好友注册成功后您将获得积分奖励。'
    },
    {
      question: '忘记密码怎么办？',
      answer: '在登录页面点击"忘记密码"，通过手机验证码即可重置密码。'
    }
  ];

  return (
    <div style={{ maxWidth: 1200, margin: '20px auto', padding: '0 16px' }}>
      {/* 页面标题 */}
      <div style={{ textAlign: 'center', marginBottom: '40px' }}>
        <Title level={1}>联系我们</Title>
        <Paragraph style={{ fontSize: '16px', color: '#666' }}>
          我们随时为您提供帮助和支持，如有任何问题请随时联系我们
        </Paragraph>
      </div>

      {/* 联系方式 */}
      <Card style={{ marginBottom: '40px' }}>
        <Title level={3} style={{ textAlign: 'center', marginBottom: '30px' }}>
          <UserOutlined style={{ marginRight: '8px', color: '#1890ff' }} />
          联系方式
        </Title>
        <Row gutter={[24, 24]}>
          {contactMethods.map((method, index) => (
            <Col xs={24} sm={12} md={6} key={index}>
              <Card 
                hoverable
                style={{ 
                  height: '160px',
                  textAlign: 'center',
                  border: '1px solid #f0f0f0'
                }}
                bodyStyle={{ 
                  padding: '20px',
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center'
                }}
              >
                <div style={{ 
                  fontSize: '32px', 
                  color: '#1890ff', 
                  marginBottom: '12px' 
                }}>
                  {method.icon}
                </div>
                <Title level={5} style={{ marginBottom: '8px' }}>
                  {method.title}
                </Title>
                <Text strong style={{ fontSize: '16px', marginBottom: '8px', display: 'block' }}>
                  {method.content}
                </Text>
                <Text style={{ color: '#666', fontSize: '12px' }}>
                  {method.description}
                </Text>
              </Card>
            </Col>
          ))}
        </Row>
      </Card>

      {/* 服务时间 */}
      <Card style={{ marginBottom: '40px' }}>
        <Title level={3} style={{ textAlign: 'center', marginBottom: '30px' }}>
          <ClockCircleOutlined style={{ marginRight: '8px', color: '#52c41a' }} />
          服务时间
        </Title>
        <Row gutter={[16, 16]}>
          {businessHours.map((schedule, index) => (
            <Col xs={24} md={8} key={index}>
              <Card style={{ textAlign: 'center' }}>
                <Title level={5}>{schedule.day}</Title>
                <Text style={{ fontSize: '16px', color: '#1890ff', display: 'block', marginBottom: '8px' }}>
                  {schedule.time}
                </Text>
                <Text style={{ color: '#666' }}>{schedule.status}</Text>
              </Card>
            </Col>
          ))}
        </Row>
      </Card>

      {/* 常见问题 */}
      <Card style={{ marginBottom: '40px' }}>
        <Title level={3} style={{ textAlign: 'center', marginBottom: '30px' }}>
          <SafetyOutlined style={{ marginRight: '8px', color: '#fa8c16' }} />
          常见问题
        </Title>
        <Row gutter={[16, 16]}>
          {faqItems.map((item, index) => (
            <Col xs={24} md={12} key={index}>
              <Card style={{ height: '120px' }}>
                <Title level={5} style={{ color: '#1890ff', marginBottom: '8px' }}>
                  Q: {item.question}
                </Title>
                <Text style={{ color: '#666' }}>
                  A: {item.answer}
                </Text>
              </Card>
            </Col>
          ))}
        </Row>
      </Card>

      {/* 公司信息 */}
      <Card style={{ marginBottom: '40px' }}>
        <Title level={3} style={{ textAlign: 'center', marginBottom: '30px' }}>
          <EnvironmentOutlined style={{ marginRight: '8px', color: '#722ed1' }} />
          公司信息
        </Title>
        <Row gutter={[24, 24]}>
          <Col xs={24} md={12}>
            <Title level={4}>公司名称</Title>
            <Text>漳浦声语文化传媒有限公司</Text>
            <br /><br />
            <Title level={4}>经营范围</Title>
            <Text>软件开发、技术咨询、计算机系统集成</Text>
            <br /><br />
            <Title level={4}>注册地址</Title>
            <Text>福建省漳浦县绥安镇富丽城市花园7栋307</Text>
          </Col>
          <Col xs={24} md={12}>
            <Title level={4}>ICP备案</Title>
            <Text>闽ICP备2025109602号-6</Text>
            <br /><br />
            <Title level={4}>软件著作权</Title>
            <Text>管理师软件 V1.0（申请中）</Text>
            <br /><br />
            <Title level={4}>成立时间</Title>
            <Text>2025年10月</Text>
          </Col>
        </Row>
      </Card>

      {/* 快速操作 */}
      <Card style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}>
        <div style={{ textAlign: 'center', color: 'white' }}>
          <Title level={3} style={{ color: 'white', marginBottom: '16px' }}>
            快速操作
          </Title>
          <Paragraph style={{ color: 'white', fontSize: '16px', marginBottom: '20px' }}>
            选择您需要的服务，我们将尽快为您处理
          </Paragraph>
          <Space size="large">
            <Button 
              type="primary" 
              size="large"
              style={{ 
                background: 'white', 
                color: '#667eea',
                border: 'none',
                fontWeight: 'bold'
              }}
              onClick={() => window.location.href = '/'}
            >
              立即使用
            </Button>
            <Button 
              size="large"
              style={{ 
                background: 'transparent', 
                color: 'white',
                border: '1px solid white'
              }}
              onClick={() => window.location.href = '/product'}
            >
              产品介绍
            </Button>
            <Button 
              size="large"
              style={{ 
                background: 'transparent', 
                color: 'white',
                border: '1px solid white'
              }}
              onClick={() => window.location.href = '/terms'}
            >
              用户协议
            </Button>
          </Space>
        </div>
      </Card>

      {/* 版权信息 */}
      <div style={{ textAlign: 'center', marginTop: '40px', padding: '20px', background: '#f5f5f5', borderRadius: '8px' }}>
        <Text style={{ color: '#999' }}>
          © 2025 漳浦声语文化传媒有限公司 版权所有 | 
          <a href="/terms" style={{ margin: '0 8px' }}>用户协议</a> | 
          <a href="/privacy" style={{ margin: '0 8px' }}>隐私政策</a> | 
          <a href="/billing" style={{ margin: '0 8px' }}>付费条款</a>
        </Text>
      </div>
    </div>
  );
};

export default Contact;
